import useWidth from '../../../../components/Hooks/useWidth';
import useOrderBookStore from '../../../../stores/OrderBook/orderBook.store';
import useOrderBook from '../../../order-book/hooks/useOrderBook';
import {
  getSavedProductDetailsPreferences,
  resolvePreferredProductColorId,
  resolveProductDetailsOrderIds,
} from './useOpenProductDetails.utils';

const useProductDetailsPreferences = () => {
  const { mobileWidth } = useWidth();
  const selectedOrder = useOrderBookStore((state) => state.selectedOrder);
  const { allOrders } = useOrderBook();

  const getProductDetailsPreferences = (productColorId?: string) => {
    const savedPreferences = getSavedProductDetailsPreferences();

    return {
      productColorId: resolvePreferredProductColorId(productColorId),
      availability: savedPreferences.availabilityFilter,
      shouldApplyRelatedProducts: savedPreferences.applyRelatedProducts,
      orderIds: resolveProductDetailsOrderIds({
        shouldApplyAllOrders: savedPreferences.applyAllOrders && !mobileWidth,
        allOrders,
        selectedOrderId: selectedOrder?.id,
      }),
    };
  };

  return { getProductDetailsPreferences };
};

export default useProductDetailsPreferences;
